// The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work.
import React, { useRef, useState, useEffect } from "react";
import * as Yup from "yup";
import { Link, useNavigate, useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { LightModeOutlined } from "@mui/icons-material";
import { parentController } from "../../_api/controllers/parent.controller.ts";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { studentControler } from "../../_api/controllers/student.controller.ts";
import { useLogout } from "../../_api/useAuth.js";
import HasRole from "../../component/_elements/HasRole.tsx";
import { useAuth } from "../../_api/auth.js";
import MyLoader from "../../component/loader/MyLoader.tsx";
import {
  birthDateSchema,
  phoneSchema,
} from "../../validators/common.schema.ts";

const NewStudent: React.FC = () => {
  // État pour les onglets et le modal
  const [activeTab, setActiveTab] = useState("informations");
  const [showAddParentForm, setShowAddParentForm] = useState(false);

  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };
  const [formData, setFormData] = useState({
    // Informations personnelles
    photo: "",
    nom: "",
    postnom: "",
    prenom: "",
    genre: "",
    lieuNaissance: "",
    dateNaissance: "",
    uid: "12345678",
    parent_id: "",
    // numeroEtudiant: "STD-2025-" + Math.floor(1000 + Math.random() * 9000),
    // Coordonnées
    adresse: {
      avenue: "",
      quartier: "",
      commune: "",
      ville: "",
      telephone: "",
    },
    contacts: {
      type: "",
      nom: "",
      postnom: "",
      prenom: "",
      genre: "",
      avenue: "",
      quartier: "",
      commune: "",
      ville: "",
      telephone: "",
      email: "",
      profession: "",
    },
    // email: "",
    // adresseSecondaire: {
    //   rue: "",
    //   codePostal: "",
    //   ville: "",
    // },
    // Informations scolaires
    // classe: "",
    // anneeScolaire: "2025 - 2026",
    // options: [],
    // regime: "",
    // dateEntree: "",
    // Contacts d'urgence
  });

  const [notification, setNotification] = useState<any>(null); // { message, type }

  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };

  //Handle mouse click outside for dropdowns
  const MenuDropdownRef = React.useRef<HTMLDivElement>(null);
  const logout = useLogout();
  //get User context && from localstorage
  const { user } = useAuth();
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //export button
      if (
        MenuDropdownRef.current &&
        !MenuDropdownRef.current.contains(event.target as Node)
      ) {
        setIsUserMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //Onchange Adress
  const handleAdresseChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      adresse: { ...prev.adresse, [name]: value },
    }));
  };

  //Onchange A
  const handleContactsChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      contacts: { ...prev.contacts, [name]: value },
    }));
  };

  // État pour la gestion du drag and drop de la photo
  const [dragActive, setDragActive] = useState<boolean>(false);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  // Référence pour l'input de fichier
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Fonctions pour la gestion du drag and drop
  const handleDrag = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };
  const handleFile = (file: File) => {
    // Vérifier si le fichier est une image
    if (!file.type.match("image.*")) {
      alert("Veuillez sélectionner une image");
      return;
    }
    // Créer une URL pour prévisualiser l'image
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    // Mettre à jour l'état avec le fichier
    setFormData((prev) => ({
      ...prev,
      photo: file.name,
    }));
  };
  const onButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // État pour le mode sombre
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  // Fonction pour basculer le mode sombre
  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1); // This goes back to the previous page
  };

  // This regular expression checks for:
  // 1. A "+" followed by a country code (e.g., +1, +44, etc.)
  // 2. Then, 10 digits for the phone number (or adjust the length to your requirements).
  const phoneNumberSchema = Yup.string().matches(
    /^\+(\d{1,3})\d{7,14}$/, // Example: +1 followed by 10-15 digits
    "Entrer l'indicatif de pays suivi d'un numéro valide",
  );

  // Validate usage in a form:
  const validatePhoneNumber = async (phoneNumber: any, nextTab: string) => {
    if (
      !!formData.adresse.telephone.trim() ||
      !!formData.contacts.telephone.trim()
    ) {
      try {
        await phoneNumberSchema.validate(phoneNumber);
        setActiveTab(nextTab);
        // console.log("Phone number is valid!");
      } catch (error: any) {
        console.error("Validation error:", error.message);
        return showNotification(error.message, "error");
      }
    }
  };

  const queryClient = useQueryClient();
  //fetch anne parents
  const { data: parentData } = useQuery({
    queryKey: ["parents"],
    queryFn: parentController.getAll,
  });

  const parentsDataArr = parentData?.data || [];

  const mutationCreateParent = useMutation({
    mutationFn: () =>
      parentController.create({
        nom: formData.contacts.nom,
        postnom: formData.contacts.postnom,
        prenom: formData.contacts.prenom,
        sexe: formData.contacts.genre,
        ville: formData.contacts.ville,
        commune: formData.contacts.commune,
        quartier: formData.contacts.quartier,
        avenue: formData.contacts.avenue,
        telephone: formData.contacts.telephone,
        email: formData.contacts.email,
        profession: formData.contacts.profession,
        type: formData.contacts.type,
      }),

    onSuccess: (data) => {
      // data.data;
      const parentId = data?.data?.id;
      // console.log("=========================");
      // console.log(data.data);
      // console.log(parentId);

      if (!parentId) {
        return showNotification(
          "Impossible de récupérer les informations du parent",
          "error",
        );
      }
      //student mutation
      mutationCreateStudentMeth1.mutate(parentId);
    },

    onError: (err) => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  //create student sequetially with the id parent generated after creation of parent
  const mutationCreateStudentMeth1 = useMutation({
    mutationFn: (idParent) =>
      studentControler.create({
        nom: formData.nom,
        postnom: formData.postnom,
        prenom: formData.prenom,
        sexe: formData.genre,
        ville: formData.adresse.ville,
        commune: formData.adresse.commune,
        quartier: formData.adresse.quartier,
        avenue: formData.adresse.avenue,
        telephone: formData.adresse.telephone,
        uid: "12345688",
        date_naissance: formData.dateNaissance,
        lieu_naissance: formData.lieuNaissance,
        parent_id: idParent,
      }),

    onSuccess: (data) => {
      // data.data;
      // console.log("=========================");
      // console.log(data);
      showNotification("Inscription effectuée avec success", "success");
      queryClient.invalidateQueries({ queryKey: ["students"] });
      queryClient.invalidateQueries({ queryKey: ["parents"] });

      setTimeout(() => {
        navigate("/parametre");
      }, 3000);
    },

    onError: (err) => {
      // console.log("=================");
      // console.log(err);
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  //create student with the existing parent
  const mutationCreateStudentMeth2 = useMutation({
    mutationFn: () =>
      studentControler.create({
        nom: formData.nom,
        postnom: formData.postnom,
        prenom: formData.prenom,
        sexe: formData.genre,
        ville: formData.adresse.ville,
        commune: formData.adresse.commune,
        quartier: formData.adresse.quartier,
        avenue: formData.adresse.avenue,
        telephone: formData.adresse.telephone,
        uid: "12345688",
        date_naissance: formData.dateNaissance,
        lieu_naissance: formData.lieuNaissance,
        parent_id: formData.parent_id,
      }),

    onSuccess: (data) => {
      // console.log(data);
      // data.data;
      showNotification("Inscription effectuée avec success", "success");
      queryClient.invalidateQueries({ queryKey: ["students"] });
      queryClient.invalidateQueries({ queryKey: ["parents"] });
      setTimeout(() => {
        navigate("/parametre");
      }, 3000);
    },

    onError: (error) => {
      // console.log("============");
      // console.log(error);
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const handleCreateStudentAndParent = () => {
    mutationCreateParent.mutate();
  };
  const handleCreateStudent = () => {
    mutationCreateStudentMeth2.mutate();
  };
  return (
    <div className="md:ml-60 w-full">
      {/* Header */}
      <header
        className={`fixed top-0 left-20 md:left-60 right-0 z-50 h-16 border-b transition-colors ${
          isDarkMode
            ? "border-[#30363D] bg-[#0D1117]/95"
            : "border-gray-200 bg-white/95"
        } backdrop-blur-md`}
      >
        <div className="flex h-full items-center justify-between gap-4 px-4 sm:px-5 lg:px-6">
          {/* ==================================================
        LEFT — NAVIGATION
    ================================================== */}
          <div className="flex min-w-0 items-center">
            <button
              onClick={goBack}
              className={`group flex h-9 items-center gap-2.5 rounded-lg border px-3 transition ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                  : "border-gray-200 bg-white text-gray-700 hover:bg-gray-50"
              }`}
            >
              <div
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md transition ${
                  isDarkMode
                    ? "bg-blue-500/10 text-blue-400 group-hover:bg-blue-500/15"
                    : "bg-blue-50 text-blue-600 group-hover:bg-blue-100"
                }`}
              >
                <i className="fas fa-arrow-left text-[8px]" />
              </div>

              {/* Desktop */}
              <div className="hidden text-left sm:block">
                <p
                  className={`whitespace-nowrap text-[10px] font-semibold leading-none ${
                    isDarkMode ? "text-gray-200" : "text-gray-700"
                  }`}
                >
                  Retour à la liste
                </p>
              </div>

              {/* Mobile */}
              <span
                className={`whitespace-nowrap text-[10px] font-medium sm:hidden ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Retour
              </span>
            </button>
          </div>

          {/* ==================================================
        RIGHT — ACTIONS
    ================================================== */}
          <div className="flex shrink-0 items-center gap-2">
            {/* Dark / Light mode */}
            <button
              onClick={toggleDarkMode}
              title={isDarkMode ? "Mode clair" : "Mode sombre"}
              className={`flex h-9 w-9 items-center justify-center rounded-lg border transition ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22] text-amber-400 hover:bg-[#21262D]"
                  : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900"
              }`}
            >
              {isDarkMode ? (
                <LightModeOutlined sx={{ fontSize: 16 }} />
              ) : (
                <i className="fas fa-moon text-[11px]" />
              )}
            </button>

            {/* ==================================================
          NOTIFICATIONS
          Aucun comportement n'est ajouté :
          le bouton reste tel qu'il était fonctionnellement.
      ================================================== */}
            {/* <button
              title="Notifications"
              className={`relative flex h-9 w-9 items-center justify-center rounded-lg border transition ${
                isDarkMode
                  ? "border-[#30363D] bg-[#161B22] text-gray-400 hover:bg-[#21262D] hover:text-gray-200"
                  : "border-gray-200 bg-white text-gray-500 hover:bg-gray-50 hover:text-gray-800"
              }`}
            >
              <i className="fas fa-bell text-[11px]" />
            </button> */}

            {/* Separator */}
            <div
              className={`mx-1 hidden h-6 w-px sm:block ${
                isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
              }`}
            />

            {/* ==================================================
          USER ACCOUNT
      ================================================== */}
            <div className="relative" ref={MenuDropdownRef}>
              <button
                id="userMenuButton"
                onClick={toggleUserMenu}
                className={`group flex h-10 items-center gap-2 rounded-xl border p-1 pr-1 transition sm:pr-2 ${
                  isUserMenuOpen
                    ? isDarkMode
                      ? "border-blue-500/40 bg-[#161B22]"
                      : "border-blue-200 bg-blue-50/50"
                    : isDarkMode
                      ? "border-transparent hover:border-[#30363D] hover:bg-[#161B22]"
                      : "border-transparent hover:border-gray-200 hover:bg-gray-50"
                }`}
              >
                {/* Avatar */}
                <div
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                    isDarkMode
                      ? "bg-blue-500/10 text-blue-400"
                      : "bg-blue-50 text-blue-600"
                  }`}
                >
                  <i className="fas fa-user text-[10px]" />
                </div>

                {/* User info */}
                <div className="hidden max-w-[150px] min-w-0 text-left lg:block">
                  <p
                    className={`truncate text-[10px] font-semibold leading-tight ${
                      isDarkMode ? "text-gray-200" : "text-gray-700"
                    }`}
                  >
                    Mon compte
                  </p>

                  <p className="mt-0.5 truncate text-[8px] leading-tight text-gray-500">
                    {user?.email}
                  </p>
                </div>

                <i
                  className={`fas fa-chevron-down hidden text-[7px] text-gray-500 transition-transform duration-200 sm:block ${
                    isUserMenuOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* ==================================================
            USER DROPDOWN
        ================================================== */}
              {isUserMenuOpen && (
                <div
                  className={`absolute right-0 top-full mt-2 w-[280px] overflow-hidden rounded-xl border shadow-2xl ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#161B22]"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  {/* ================= ACCOUNT ================= */}
                  <div
                    className={`border-b p-3.5 ${
                      isDarkMode ? "border-[#30363D]" : "border-gray-200"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {/* Avatar */}
                      <div
                        className={`relative flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-user text-xs" />

                        {/* Online indicator */}
                        <span
                          className={`absolute -bottom-0.5 -right-0.5 flex h-3 w-3 items-center justify-center rounded-full ${
                            isDarkMode ? "bg-[#161B22]" : "bg-white"
                          }`}
                        >
                          <span className="h-2 w-2 rounded-full bg-emerald-500" />
                        </span>
                      </div>

                      {/* Account details */}
                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-1.5">
                          <p
                            className={`text-[11px] font-semibold ${
                              isDarkMode ? "text-gray-200" : "text-gray-800"
                            }`}
                          >
                            Mon compte
                          </p>

                          <span
                            className={`rounded-full px-1.5 py-0.5 text-[7px] font-medium ${
                              isDarkMode
                                ? "bg-emerald-500/10 text-emerald-400"
                                : "bg-emerald-50 text-emerald-600"
                            }`}
                          >
                            Actif
                          </span>
                        </div>

                        <p
                          className="mt-1 truncate text-[9px] text-gray-500"
                          title={user?.email}
                        >
                          {user?.email}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* ================= MENU ================= */}
                  <div className="p-1.5">
                    {/* Profile */}
                    <Link
                      to="/profil"
                      className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 transition ${
                        isDarkMode
                          ? "text-gray-300 hover:bg-[#21262D]"
                          : "text-gray-700 hover:bg-gray-50"
                      }`}
                    >
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode
                            ? "bg-blue-500/10 text-blue-400"
                            : "bg-blue-50 text-blue-600"
                        }`}
                      >
                        <i className="fas fa-user-circle text-[10px]" />
                      </div>

                      <div className="min-w-0 flex-1">
                        <p className="text-[10px] font-medium">
                          Voir le profil
                        </p>

                        <p className="mt-0.5 text-[8px] text-gray-500">
                          Informations personnelles
                        </p>
                      </div>

                      <i className="fas fa-chevron-right text-[7px] text-gray-500 opacity-0 transition group-hover:opacity-100" />
                    </Link>

                    {/* Settings */}
                    <HasRole allowedRoles={["Administrateur", "Comptable"]}>
                      <Link
                        to="/parametre"
                        className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 transition ${
                          isDarkMode
                            ? "text-gray-300 hover:bg-[#21262D]"
                            : "text-gray-700 hover:bg-gray-50"
                        }`}
                      >
                        <div
                          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                            isDarkMode
                              ? "bg-purple-500/10 text-purple-400"
                              : "bg-purple-50 text-purple-600"
                          }`}
                        >
                          <i className="fas fa-cog text-[10px]" />
                        </div>

                        <div className="min-w-0 flex-1">
                          <p className="text-[10px] font-medium">Paramètres</p>

                          <p className="mt-0.5 text-[8px] text-gray-500">
                            Configuration de l'application
                          </p>
                        </div>

                        <i className="fas fa-chevron-right text-[7px] text-gray-500 opacity-0 transition group-hover:opacity-100" />
                      </Link>
                    </HasRole>
                  </div>

                  {/* ================= LOGOUT ================= */}
                  <div
                    className={`border-t p-1.5 ${
                      isDarkMode ? "border-[#30363D]" : "border-gray-200"
                    }`}
                  >
                    <button
                      onClick={() => logout.mutate()}
                      className={`group flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition ${
                        isDarkMode
                          ? "text-red-400 hover:bg-red-500/10"
                          : "text-red-600 hover:bg-red-50"
                      }`}
                    >
                      <div
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${
                          isDarkMode ? "bg-red-500/10" : "bg-red-50"
                        }`}
                      >
                        <i className="fas fa-sign-out-alt text-[10px]" />
                      </div>

                      <div className="flex-1">
                        <p className="text-[10px] font-medium">Déconnexion</p>

                        <p
                          className={`mt-0.5 text-[8px] ${
                            isDarkMode ? "text-gray-500" : "text-gray-400"
                          }`}
                        >
                          Fermer votre session
                        </p>
                      </div>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
      <MyLoader
        isLoading={logout.isPending}
        message="Déconnexion en cours..."
      />
      <MyLoader
        isLoading={
          mutationCreateParent.isPending || mutationCreateStudentMeth2.isPending
        }
        message="Chargement en cours..."
      />

      {/* ==================================================
    PAGE INTRODUCTION
================================================== */}
      <div className="ml-20 md:ml-0 mt-16 px-4 pt-5 sm:px-6 lg:px-8">
        <div className="mx-auto">
          <div className="flex items-start gap-3">
            <div
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${
                isDarkMode
                  ? "bg-blue-500/10 text-blue-400"
                  : "bg-blue-50 text-blue-600"
              }`}
            >
              <i className="fas fa-user-plus text-sm" />
            </div>

            <div>
              <h1
                className={`text-lg font-semibold ${
                  isDarkMode ? "text-gray-100" : "text-gray-900"
                }`}
              >
                Nouvelle inscription
              </h1>

              <p className="mt-1 text-[11px] text-gray-500">
                Enregistrement des informations de l'élève
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ==================================================
    PROGRESS / STEPPER
================================================== */}
      <div className="ml-20 md:ml-0 px-4 pt-5 sm:px-6 lg:px-8">
        <div
          className={`mx-auto overflow-hidden rounded-xl border ${
            isDarkMode
              ? "border-[#30363D] bg-[#161B22]"
              : "border-gray-200 bg-white"
          }`}
        >
          <div className="flex items-center justify-between border-b border-inherit px-4 py-3 sm:px-5">
            <div className="flex items-center gap-2">
              <i className="fas fa-list-check text-[10px] text-blue-500" />

              <span
                className={`text-[10px] font-semibold ${
                  isDarkMode ? "text-gray-300" : "text-gray-700"
                }`}
              >
                Progression de l'inscription
              </span>
            </div>

            <span
              className={`rounded-full px-2 py-1 text-[9px] font-semibold ${
                isDarkMode
                  ? "bg-blue-500/10 text-blue-400"
                  : "bg-blue-50 text-blue-600"
              }`}
            >
              Étape{" "}
              {activeTab === "informations"
                ? "1"
                : activeTab === "coordonnees"
                  ? "2"
                  : activeTab === "contacts" && "3"}{" "}
              / 3
            </span>
          </div>

          <div className="grid grid-cols-3">
            {/* STEP 1 */}
            <div
              className={`relative flex items-center gap-3 px-3 py-3 sm:px-5 ${
                activeTab === "informations"
                  ? isDarkMode
                    ? "bg-blue-500/5"
                    : "bg-blue-50/50"
                  : ""
              }`}
            >
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border ${
                  activeTab === "informations"
                    ? "border-blue-500 bg-blue-500 text-white"
                    : activeTab === "coordonnees" || activeTab === "contacts"
                      ? "border-emerald-500 bg-emerald-500/10 text-emerald-500"
                      : isDarkMode
                        ? "border-[#30363D] bg-[#0D1117] text-gray-500"
                        : "border-gray-200 bg-gray-50 text-gray-400"
                }`}
              >
                {activeTab === "coordonnees" || activeTab === "contacts" ? (
                  <i className="fas fa-check text-[9px]" />
                ) : (
                  <i className="fas fa-user text-[9px]" />
                )}
              </div>

              <div className="hidden min-w-0 sm:block">
                <p className="text-[8px] font-medium uppercase tracking-wider text-gray-500">
                  Étape 1
                </p>
                <p
                  className={`mt-0.5 truncate text-[10px] font-semibold ${
                    activeTab === "informations"
                      ? "text-blue-500"
                      : isDarkMode
                        ? "text-gray-300"
                        : "text-gray-700"
                  }`}
                >
                  Informations
                </p>
              </div>

              {activeTab === "informations" && (
                <div className="absolute bottom-0 left-0 h-0.5 w-full bg-blue-500" />
              )}
            </div>

            {/* STEP 2 */}
            <div
              className={`relative flex items-center gap-3 border-x px-3 py-3 sm:px-5 ${
                isDarkMode ? "border-[#30363D]" : "border-gray-200"
              } ${
                activeTab === "coordonnees"
                  ? isDarkMode
                    ? "bg-blue-500/5"
                    : "bg-blue-50/50"
                  : ""
              }`}
            >
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border ${
                  activeTab === "coordonnees"
                    ? "border-blue-500 bg-blue-500 text-white"
                    : activeTab === "contacts"
                      ? "border-emerald-500 bg-emerald-500/10 text-emerald-500"
                      : isDarkMode
                        ? "border-[#30363D] bg-[#0D1117] text-gray-500"
                        : "border-gray-200 bg-gray-50 text-gray-400"
                }`}
              >
                {activeTab === "contacts" ? (
                  <i className="fas fa-check text-[9px]" />
                ) : (
                  <i className="fas fa-location-dot text-[9px]" />
                )}
              </div>

              <div className="hidden min-w-0 sm:block">
                <p className="text-[8px] font-medium uppercase tracking-wider text-gray-500">
                  Étape 2
                </p>
                <p
                  className={`mt-0.5 truncate text-[10px] font-semibold ${
                    activeTab === "coordonnees"
                      ? "text-blue-500"
                      : isDarkMode
                        ? "text-gray-300"
                        : "text-gray-700"
                  }`}
                >
                  Coordonnées
                </p>
              </div>

              {activeTab === "coordonnees" && (
                <div className="absolute bottom-0 left-0 h-0.5 w-full bg-blue-500" />
              )}
            </div>

            {/* STEP 3 */}
            <div
              className={`relative flex items-center gap-3 px-3 py-3 sm:px-5 ${
                activeTab === "contacts"
                  ? isDarkMode
                    ? "bg-blue-500/5"
                    : "bg-blue-50/50"
                  : ""
              }`}
            >
              <div
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border ${
                  activeTab === "contacts"
                    ? "border-blue-500 bg-blue-500 text-white"
                    : isDarkMode
                      ? "border-[#30363D] bg-[#0D1117] text-gray-500"
                      : "border-gray-200 bg-gray-50 text-gray-400"
                }`}
              >
                <i className="fas fa-user-shield text-[9px]" />
              </div>

              <div className="hidden min-w-0 sm:block">
                <p className="text-[8px] font-medium uppercase tracking-wider text-gray-500">
                  Étape 3
                </p>
                <p
                  className={`mt-0.5 truncate text-[10px] font-semibold ${
                    activeTab === "contacts"
                      ? "text-blue-500"
                      : isDarkMode
                        ? "text-gray-300"
                        : "text-gray-700"
                  }`}
                >
                  Parent / Tuteur
                </p>
              </div>

              {activeTab === "contacts" && (
                <div className="absolute bottom-0 left-0 h-0.5 w-full bg-blue-500" />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ==================================================
    MAIN FORM
================================================== */}
      <main className="ml-20 md:ml-0 px-4 py-5 pb-24 sm:px-6 lg:px-8">
        <div
          className={`mx-auto overflow-hidden rounded-xl border ${
            isDarkMode
              ? "border-[#30363D] bg-[#161B22]"
              : "border-gray-200 bg-white"
          }`}
        >
          {/* Onglets */}
          {/* ==================================================
    TABS
================================================== */}
          <div
            className={`border-b px-3 pt-3 ${
              isDarkMode ? "border-[#30363D]" : "border-gray-200"
            }`}
          >
            <nav
              className={`flex w-full gap-1 rounded-lg p-1 sm:w-fit ${
                isDarkMode ? "bg-[#0D1117]" : "bg-gray-100"
              }`}
            >
              {/* Conserve ici tes 3 boutons et leurs onClick EXACTS */}

              <button
                onClick={() => setActiveTab("informations")}
                className={`flex h-9 items-center gap-2 rounded-md px-3 text-[10px] font-medium transition ${
                  activeTab === "informations"
                    ? isDarkMode
                      ? "bg-[#21262D] text-blue-400 shadow-sm"
                      : "bg-white text-blue-600 shadow-sm"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <i className="fas fa-user text-[9px]" />
                <span className="hidden sm:inline">
                  Informations personnelles
                </span>
                <span className="sm:hidden">Infos</span>
              </button>

              {/* Pour Coordonnées :
        CONSERVE ton onClick actuel intégralement */}
              <button
                onClick={() => {
                  const { ville, commune, quartier, avenue } = formData.adresse;
                  if (
                    !ville.trim() ||
                    !commune.trim() ||
                    !quartier.trim() ||
                    !avenue.trim()
                  ) {
                    return showNotification(
                      "Veuillez compléter tous les champs obligatoires",
                      "error",
                    );
                  } else {
                    setActiveTab("coordonnees");
                  }
                }}
                className={`flex h-9 items-center gap-2 rounded-md px-3 text-[10px] font-medium transition ${
                  activeTab === "coordonnees"
                    ? isDarkMode
                      ? "bg-[#21262D] text-blue-400 shadow-sm"
                      : "bg-white text-blue-600 shadow-sm"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <i className="fas fa-location-dot text-[9px]" />
                <span>Coordonnées</span>
              </button>

              {/* Pour Contact :
        CONSERVE ton onClick actuel intégralement */}
              <button
                onClick={() => {
                  const { ville, commune, quartier, avenue, telephone } =
                    formData.adresse;

                  if (
                    !ville.trim() ||
                    !commune.trim() ||
                    !quartier.trim() ||
                    !avenue.trim()
                  ) {
                    return showNotification(
                      "Veuillez compléter tous les champs obligatoires",
                      "error",
                    );
                  }

                  if (telephone.trim()) {
                    validatePhoneNumber(telephone, "contacts");
                  } else {
                    setActiveTab("contacts");
                  }
                }}
                className={`flex h-9 items-center gap-2 rounded-md px-3 text-[10px] font-medium transition ${
                  activeTab === "contacts"
                    ? isDarkMode
                      ? "bg-[#21262D] text-blue-400 shadow-sm"
                      : "bg-white text-blue-600 shadow-sm"
                    : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <i className="fas fa-user-shield text-[9px]" />
                <span className="hidden sm:inline">Contact d'urgence</span>
                <span className="sm:hidden">Contact</span>
              </button>
            </nav>
          </div>

          <div className="p-4 sm:p-5 lg:p-6">
            {/* Informations personnelles */}
            {activeTab === "informations" && (
              <div className="space-y-5">
                {/* Section heading */}
                <div className="flex items-center gap-3">
                  <div
                    className={`flex h-9 w-9 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-blue-500/10 text-blue-400"
                        : "bg-blue-50 text-blue-600"
                    }`}
                  >
                    <i className="fas fa-id-card text-[11px]" />
                  </div>

                  <div>
                    <h2
                      className={`text-sm font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      Informations personnelles
                    </h2>
                    <p className="mt-0.5 text-[9px] text-gray-500">
                      Identité et informations générales de l'élève
                    </p>
                  </div>
                </div>

                <div
                  className={`h-px ${
                    isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
                  }`}
                />

                <div className="grid grid-cols-1 gap-6 lg:grid-cols-[240px_1fr]">
                  {/* ================= PHOTO ================= */}
                  <div>
                    <label
                      className={`mb-2 block text-[10px] font-medium ${
                        isDarkMode ? "text-gray-300" : "text-gray-700"
                      }`}
                    >
                      Photo de l'élève
                    </label>

                    <div
                      className={`group flex h-[250px] items-center justify-center overflow-hidden rounded-xl border border-dashed transition ${
                        dragActive
                          ? "border-blue-500 bg-blue-500/5"
                          : isDarkMode
                            ? "border-[#30363D] bg-[#0D1117]"
                            : "border-gray-300 bg-gray-50"
                      }`}
                      onDragEnter={handleDrag}
                      onDragOver={handleDrag}
                      onDragLeave={handleDrag}
                      onDrop={handleDrop}
                    >
                      {previewUrl ? (
                        <div className="relative h-full w-full p-2">
                          <img
                            src={previewUrl}
                            alt="Aperçu"
                            className="h-full w-full rounded-lg object-contain"
                          />
                        </div>
                      ) : (
                        <div className="flex flex-col items-center px-5 text-center">
                          <div
                            className={`mb-3 flex h-14 w-14 items-center justify-center rounded-xl ${
                              isDarkMode
                                ? "bg-[#161B22] text-gray-500"
                                : "bg-white text-gray-400"
                            }`}
                          >
                            <i className="fas fa-camera text-xl" />
                          </div>

                          <p
                            className={`text-[10px] font-medium ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Ajouter une photo
                          </p>

                          <p className="mt-1 max-w-[180px] text-[9px] leading-relaxed text-gray-500">
                            Glissez une image ici ou sélectionnez un fichier
                          </p>

                          <label
                            htmlFor="file-upload"
                            className="mt-3 cursor-pointer text-[10px] font-semibold text-blue-500 hover:text-blue-600"
                          >
                            <span onClick={onButtonClick}>
                              Parcourir les fichiers
                            </span>

                            <input
                              id="file-upload"
                              name="file-upload"
                              type="file"
                              className="sr-only"
                              ref={fileInputRef}
                              onChange={handleFileChange}
                              accept="image/*"
                            />
                          </label>

                          <p className="mt-2 text-[8px] text-gray-500">
                            PNG, JPG, GIF jusqu'à 10MB
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* ================= STUDENT INFORMATION ================= */}
                  <div className="grid grid-cols-1 content-start gap-4 sm:grid-cols-2">
                    {/* NOM */}
                    <div>
                      <label
                        htmlFor="nom"
                        className={`mb-1.5 block text-[10px] font-medium ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        <i className="fas fa-user mr-1.5 text-[8px] text-gray-500" />
                        Nom <span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        name="nom"
                        id="nom"
                        required
                        value={formData.nom}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            nom: e.target.value,
                          }));
                        }}
                        className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117] text-gray-200 placeholder:text-gray-600"
                            : "border-gray-200 bg-white text-gray-700 placeholder:text-gray-400"
                        }`}
                      />
                    </div>

                    {/* POST-NOM */}
                    <div>
                      <label
                        htmlFor="postnom"
                        className={`mb-1.5 block text-[10px] font-medium ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        <i className="fas fa-user mr-1.5 text-[8px] text-gray-500" />
                        Post-Nom <span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        name="postnom"
                        id="postnom"
                        required
                        value={formData.postnom}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            postnom: e.target.value,
                          }));
                        }}
                        className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                            : "border-gray-200 bg-white text-gray-700"
                        }`}
                      />
                    </div>

                    {/* PRENOM */}
                    <div>
                      <label
                        htmlFor="prenom"
                        className={`mb-1.5 block text-[10px] font-medium ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        <i className="fas fa-user mr-1.5 text-[8px] text-gray-500" />
                        Prénom <span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        name="prenom"
                        id="prenom"
                        required
                        value={formData.prenom}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            prenom: e.target.value,
                          }));
                        }}
                        className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                            : "border-gray-200 bg-white text-gray-700"
                        }`}
                      />
                    </div>

                    {/* GENRE */}
                    <div>
                      <label
                        htmlFor="genre"
                        className={`mb-1.5 block text-[10px] font-medium ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        <i className="fas fa-venus-mars mr-1.5 text-[8px] text-gray-500" />
                        Genre
                      </label>

                      <select
                        id="genre"
                        name="genre"
                        value={formData.genre}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            genre: e.target.value,
                          }));
                        }}
                        className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                            : "border-gray-200 bg-white text-gray-700"
                        }`}
                      >
                        <option value="">Sélectionner</option>
                        <option value="M">Masculin</option>
                        <option value="F">Féminin</option>
                      </select>
                    </div>

                    {/* LIEU NAISSANCE */}
                    <div>
                      <label
                        htmlFor="lieuNaissance"
                        className={`mb-1.5 block text-[10px] font-medium ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        <i className="fas fa-location-dot mr-1.5 text-[8px] text-gray-500" />
                        Lieu de Naissance{" "}
                        <span className="text-red-500">*</span>
                      </label>

                      <input
                        type="text"
                        name="lieuNaissance"
                        id="lieuNaissance"
                        required
                        value={formData.lieuNaissance}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            lieuNaissance: e.target.value,
                          }));
                        }}
                        className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                            : "border-gray-200 bg-white text-gray-700"
                        }`}
                      />
                    </div>

                    {/* DATE NAISSANCE */}
                    <div>
                      <label
                        htmlFor="dateNaissance"
                        className={`mb-1.5 block text-[10px] font-medium ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        <i className="fas fa-calendar-days mr-1.5 text-[8px] text-gray-500" />
                        Date de naissance{" "}
                        <span className="text-red-500">*</span>
                      </label>

                      <input
                        type="date"
                        name="dateNaissance"
                        id="dateNaissance"
                        required
                        value={formData.dateNaissance}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            dateNaissance: e.target.value,
                          }));
                        }}
                        className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#0D1117] text-gray-200"
                            : "border-gray-200 bg-white text-gray-700"
                        }`}
                      />
                    </div>
                  </div>
                </div>

                {/* ================= FOOTER ================= */}
                <div
                  className={`fixed bottom-0 left-20 right-0 z-40 border-t backdrop-blur-md md:left-60 ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#0D1117]/95"
                      : "border-gray-200 bg-white/95"
                  }`}
                >
                  <div className="flex h-16 items-center justify-end gap-2 px-4 sm:px-6 lg:px-8">
                    <Link
                      to={"/eleves"}
                      className={`flex h-9 items-center gap-2 rounded-lg border px-4 text-[10px] font-medium transition ${
                        isDarkMode
                          ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                          : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      <i className="fas fa-times text-[8px]" />
                      Annuler
                    </Link>

                    <button
                      type="button"
                      onClick={() => {
                        const {
                          nom,
                          postnom,
                          prenom,
                          genre,
                          lieuNaissance,
                          dateNaissance,
                        } = formData;

                        if (
                          !nom.trim() ||
                          !postnom.trim() ||
                          !prenom.trim() ||
                          !genre.trim() ||
                          !dateNaissance.trim() ||
                          !lieuNaissance.trim()
                        ) {
                          return showNotification(
                            "Veuillez compléter tous les champs obligatoires",
                            "error",
                          );
                        }
                        // verifie si la date est 5 ans au moins
                        const result = birthDateSchema.safeParse(dateNaissance);

                        if (!result.success) {
                          return showNotification(
                            result.error.issues[0].message,
                            "error",
                          );
                        } else {
                          setActiveTab("coordonnees");
                        }
                      }}
                      className="flex h-9 items-center gap-2 rounded-lg bg-blue-600 px-4 text-[10px] font-semibold text-white transition hover:bg-blue-700"
                    >
                      Suivant
                      <i className="fas fa-arrow-right text-[8px]" />
                    </button>
                  </div>
                </div>
              </div>
            )}
            {/* Coordonnées */}
            {activeTab === "coordonnees" && (
              <div className="space-y-5">
                {/* ==================================================
        SECTION HEADER
    ================================================== */}
                <div className="flex items-center gap-3">
                  <div
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-emerald-500/10 text-emerald-400"
                        : "bg-emerald-50 text-emerald-600"
                    }`}
                  >
                    <i className="fas fa-location-dot text-[11px]" />
                  </div>

                  <div>
                    <h2
                      className={`text-sm font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      Coordonnées
                    </h2>

                    <p className="mt-0.5 text-[9px] text-gray-500">
                      Adresse principale et coordonnées de l'élève
                    </p>
                  </div>
                </div>

                <div
                  className={`h-px ${
                    isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
                  }`}
                />

                {/* ==================================================
        ADDRESS CARD
    ================================================== */}
                <div
                  className={`overflow-hidden rounded-xl border ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#0D1117]"
                      : "border-gray-200 bg-gray-50/50"
                  }`}
                >
                  {/* Card header */}
                  <div
                    className={`flex items-center gap-3 border-b px-4 py-3 ${
                      isDarkMode ? "border-[#30363D]" : "border-gray-200"
                    }`}
                  >
                    <div
                      className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                        isDarkMode
                          ? "bg-blue-500/10 text-blue-400"
                          : "bg-blue-50 text-blue-600"
                      }`}
                    >
                      <i className="fas fa-house text-[9px]" />
                    </div>

                    <div>
                      <h3
                        className={`text-[11px] font-semibold ${
                          isDarkMode ? "text-gray-300" : "text-gray-700"
                        }`}
                      >
                        Adresse principale
                      </h3>

                      <p className="mt-0.5 text-[8px] text-gray-500">
                        Localisation actuelle de l'élève
                      </p>
                    </div>
                  </div>

                  {/* Fields */}
                  <div className="p-4 sm:p-5">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                      {/* Avenue */}
                      <div className="sm:col-span-2 lg:col-span-2">
                        <label
                          htmlFor="avenue"
                          className={`mb-1.5 block text-[10px] font-medium ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          <i className="fas fa-road mr-1.5 text-[8px] text-gray-500" />
                          Avenue <span className="text-red-500">*</span>
                        </label>

                        <input
                          type="text"
                          name="avenue"
                          id="avenue"
                          required
                          value={formData.adresse.avenue}
                          onChange={handleAdresseChange}
                          className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                            isDarkMode
                              ? "border-[#30363D] bg-[#161B22] text-gray-200 placeholder:text-gray-600"
                              : "border-gray-200 bg-white text-gray-700 placeholder:text-gray-400"
                          }`}
                        />
                      </div>

                      {/* Quartier */}
                      <div>
                        <label
                          htmlFor="quartier"
                          className={`mb-1.5 block text-[10px] font-medium ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          <i className="fas fa-map-pin mr-1.5 text-[8px] text-gray-500" />
                          Quartier <span className="text-red-500">*</span>
                        </label>

                        <input
                          type="text"
                          name="quartier"
                          id="quartier"
                          required
                          value={formData.adresse.quartier}
                          onChange={handleAdresseChange}
                          className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                            isDarkMode
                              ? "border-[#30363D] bg-[#161B22] text-gray-200"
                              : "border-gray-200 bg-white text-gray-700"
                          }`}
                        />
                      </div>

                      {/* Commune */}
                      <div>
                        <label
                          htmlFor="commune"
                          className={`mb-1.5 block text-[10px] font-medium ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          <i className="fas fa-building mr-1.5 text-[8px] text-gray-500" />
                          Commune <span className="text-red-500">*</span>
                        </label>

                        <input
                          type="text"
                          name="commune"
                          id="commune"
                          required
                          value={formData.adresse.commune}
                          onChange={handleAdresseChange}
                          className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                            isDarkMode
                              ? "border-[#30363D] bg-[#161B22] text-gray-200"
                              : "border-gray-200 bg-white text-gray-700"
                          }`}
                        />
                      </div>

                      {/* Ville */}
                      <div className="sm:col-span-1 lg:col-span-2">
                        <label
                          htmlFor="ville"
                          className={`mb-1.5 block text-[10px] font-medium ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          <i className="fas fa-city mr-1.5 text-[8px] text-gray-500" />
                          Ville <span className="text-red-500">*</span>
                        </label>

                        <input
                          type="text"
                          required
                          name="ville"
                          id="ville"
                          value={formData.adresse.ville}
                          onChange={handleAdresseChange}
                          className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                            isDarkMode
                              ? "border-[#30363D] bg-[#161B22] text-gray-200"
                              : "border-gray-200 bg-white text-gray-700"
                          }`}
                        />
                      </div>

                      {/* Téléphone */}
                      <div className="sm:col-span-1 lg:col-span-2">
                        <label
                          htmlFor="telephone"
                          className={`mb-1.5 block text-[10px] font-medium ${
                            isDarkMode ? "text-gray-300" : "text-gray-700"
                          }`}
                        >
                          <i className="fas fa-phone mr-1.5 text-[8px] text-gray-500" />
                          Téléphone
                        </label>

                        <div className="relative">
                          <input
                            type="tel"
                            name="telephone"
                            id="telephone"
                            placeholder="Ex: +243990119611"
                            value={formData.adresse.telephone}
                            onChange={handleAdresseChange}
                            className={`h-10 w-full rounded-lg border px-3 pr-9 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-gray-200 placeholder:text-gray-600"
                                : "border-gray-200 bg-white text-gray-700 placeholder:text-gray-400"
                            }`}
                          />

                          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
                            <i className="fas fa-mobile-screen text-[9px] text-gray-500" />
                          </div>
                        </div>

                        <p className="mt-1.5 text-[8px] text-gray-500">
                          Inclure l'indicatif du pays
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ==================================================
        FOOTER
    ================================================== */}
                <div
                  className={`fixed bottom-0 left-20 right-0 z-40 border-t backdrop-blur-md md:left-60 ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#0D1117]/95"
                      : "border-gray-200 bg-white/95"
                  }`}
                >
                  <div className="flex h-16 items-center justify-between gap-3 px-4 sm:px-6 lg:px-8">
                    <button
                      type="button"
                      onClick={() => setActiveTab("informations")}
                      className={`flex h-9 items-center gap-2 rounded-lg border px-4 text-[10px] font-medium transition ${
                        isDarkMode
                          ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                          : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      <i className="fas fa-arrow-left text-[8px]" />
                      Précédent
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        //validate required filds
                        const { ville, commune, quartier, avenue } =
                          formData.adresse;
                        if (
                          !ville.trim() ||
                          !commune.trim() ||
                          !quartier.trim() ||
                          !avenue.trim()
                        ) {
                          return showNotification(
                            "Veuillez compléter tous les champs obligatoires",
                            "error",
                          );
                        }
                        //validate phone number structure
                        if (!!formData.adresse.telephone.trim()) {
                          validatePhoneNumber(
                            formData.adresse.telephone,
                            "contacts",
                          );
                        } else {
                          setActiveTab("contacts");
                        }
                      }}
                      className="flex h-9 items-center gap-2 rounded-lg bg-blue-600 px-4 text-[10px] font-semibold text-white transition hover:bg-blue-700"
                    >
                      Suivant
                      <i className="fas fa-arrow-right text-[8px]" />
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Contacts d'urgence */}
            {activeTab === "contacts" && (
              <div className="space-y-5">
                {/* ==================================================
        SECTION HEADER
    ================================================== */}
                <div className="flex items-center gap-3">
                  <div
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${
                      isDarkMode
                        ? "bg-purple-500/10 text-purple-400"
                        : "bg-purple-50 text-purple-600"
                    }`}
                  >
                    <i className="fas fa-user-shield text-[11px]" />
                  </div>

                  <div>
                    <h2
                      className={`text-sm font-semibold ${
                        isDarkMode ? "text-gray-200" : "text-gray-800"
                      }`}
                    >
                      Contacts d'urgence
                    </h2>

                    <p className="mt-0.5 text-[9px] text-gray-500">
                      Parent ou tuteur responsable de l'élève
                    </p>
                  </div>
                </div>

                <div
                  className={`h-px ${
                    isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
                  }`}
                />

                {/* ==================================================
        EXISTING PARENT
    ================================================== */}
                {!showAddParentForm && (
                  <div
                    className={`overflow-hidden rounded-xl border ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/50"
                    }`}
                  >
                    <div
                      className={`flex items-center justify-between gap-4 border-b px-4 py-3 ${
                        isDarkMode ? "border-[#30363D]" : "border-gray-200"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <div
                          className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                            isDarkMode
                              ? "bg-blue-500/10 text-blue-400"
                              : "bg-blue-50 text-blue-600"
                          }`}
                        >
                          <i className="fas fa-users text-[9px]" />
                        </div>

                        <div>
                          <h3
                            className={`text-[11px] font-semibold ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Parents
                          </h3>

                          <p className="mt-0.5 text-[8px] text-gray-500">
                            Sélectionnez un parent déjà enregistré
                          </p>
                        </div>
                      </div>

                      <span
                        className={`hidden rounded-full px-2 py-1 text-[8px] font-medium sm:inline ${
                          isDarkMode
                            ? "bg-emerald-500/10 text-emerald-400"
                            : "bg-emerald-50 text-emerald-600"
                        }`}
                      >
                        Parent existant
                      </span>
                    </div>

                    <div className="p-4 sm:p-5">
                      <div className="grid grid-cols-1 items-end gap-3 md:grid-cols-[1fr_auto]">
                        <div>
                          <label
                            htmlFor="idParent"
                            className={`mb-1.5 block text-[10px] font-medium ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            <i className="fas fa-user-group mr-1.5 text-[8px] text-gray-500" />
                            sélectionner parent{" "}
                            <span className="text-red-500">*</span>
                          </label>

                          <select
                            name="idParent"
                            id="idParent"
                            required
                            value={formData.parent_id}
                            onChange={(e) =>
                              setFormData((prev) => ({
                                ...prev,
                                parent_id: e.target.value,
                              }))
                            }
                            className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                              isDarkMode
                                ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                : "border-gray-200 bg-white text-gray-700"
                            }`}
                          >
                            <option value="">Sélectionner parent</option>

                            {parentsDataArr
                              .sort((a, b) =>
                                a.nom
                                  .toLowerCase()
                                  .localeCompare(b.nom.toLowerCase()),
                              )
                              .map((item) => (
                                <option
                                  key={item.parent_id}
                                  value={item.parent_id}
                                >
                                  {item.nom.toUpperCase()}{" "}
                                  {item.postnom.toUpperCase()}{" "}
                                  {item.prenom.toUpperCase()}
                                </option>
                              ))}
                          </select>
                        </div>

                        <button
                          onClick={() => setShowAddParentForm(true)}
                          className="flex h-10 items-center justify-center gap-2 rounded-lg bg-blue-600 px-4 text-[10px] font-semibold text-white transition hover:bg-blue-700"
                        >
                          <i className="fas fa-plus text-[8px]" />
                          Nouveau parent
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                {/* ==================================================
        NEW PARENT FORM
    ================================================== */}
                {showAddParentForm && (
                  <div
                    className={`overflow-hidden rounded-xl border ${
                      isDarkMode
                        ? "border-[#30363D] bg-[#0D1117]"
                        : "border-gray-200 bg-gray-50/50"
                    }`}
                  >
                    {/* Header */}
                    <div
                      className={`flex items-center justify-between gap-4 border-b px-4 py-3 ${
                        isDarkMode ? "border-[#30363D]" : "border-gray-200"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        <div
                          className={`flex h-8 w-8 items-center justify-center rounded-lg ${
                            isDarkMode
                              ? "bg-blue-500/10 text-blue-400"
                              : "bg-blue-50 text-blue-600"
                          }`}
                        >
                          <i className="fas fa-user-plus text-[9px]" />
                        </div>

                        <div>
                          <div className="flex items-center gap-2">
                            <h3
                              className={`text-[11px] font-semibold ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Contact
                            </h3>

                            <span
                              className={`rounded-full px-2 py-0.5 text-[7px] font-semibold ${
                                isDarkMode
                                  ? "bg-red-500/10 text-red-400"
                                  : "bg-red-50 text-red-600"
                              }`}
                            >
                              Principal
                            </span>
                          </div>

                          <p className="mt-0.5 text-[8px] text-gray-500">
                            Informations du nouveau parent ou tuteur
                          </p>
                        </div>
                      </div>

                      {showAddParentForm && (
                        <button
                          type="button"
                          onClick={() => setShowAddParentForm(false)}
                          className={`flex h-8 w-8 items-center justify-center rounded-lg border transition ${
                            isDarkMode
                              ? "border-[#30363D] bg-[#161B22] text-gray-400 hover:bg-red-500/10 hover:text-red-400"
                              : "border-gray-200 bg-white text-gray-500 hover:border-red-200 hover:bg-red-50 hover:text-red-600"
                          }`}
                        >
                          <i className="fas fa-times text-[9px]" />
                        </button>
                      )}
                    </div>

                    <div className="space-y-6 p-4 sm:p-5">
                      {/* ==================================================
              IDENTITY
          ================================================== */}
                      <div>
                        <div className="mb-4 flex items-center gap-2">
                          <div
                            className={`flex h-6 w-6 items-center justify-center rounded-md ${
                              isDarkMode
                                ? "bg-purple-500/10 text-purple-400"
                                : "bg-purple-50 text-purple-600"
                            }`}
                          >
                            <i className="fas fa-id-card text-[8px]" />
                          </div>

                          <p
                            className={`text-[10px] font-semibold ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Identité du contact
                          </p>
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                          {/* Type */}
                          <div>
                            <label
                              htmlFor={`type`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Type de contact{" "}
                              <span className="text-red-500">*</span>
                            </label>

                            <select
                              id={`type`}
                              name="type"
                              required
                              value={formData.contacts.type}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            >
                              <option value="">Sélectionner</option>
                              <option value="pere">Père</option>
                              <option value="mere">Mère</option>
                              <option value="tuteur">Tuteur légal</option>
                              <option value="autre">Autre</option>
                            </select>
                          </div>

                          {/* Nom */}
                          <div>
                            <label
                              htmlFor={`nom`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Nom <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              id={`nom`}
                              name="nom"
                              required
                              value={formData.contacts.nom}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Postnom */}
                          <div>
                            <label
                              htmlFor={`postnom`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Post-Nom <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              id={`postnom`}
                              name="postnom"
                              required
                              value={formData.contacts.postnom}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Prénom */}
                          <div>
                            <label
                              htmlFor={`prenom`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Prénom <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              id={`prenom`}
                              name="prenom"
                              required
                              value={formData.contacts.prenom}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Genre */}
                          <div>
                            <label
                              htmlFor={`genre`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Genre <span className="text-red-500">*</span>
                            </label>

                            <select
                              id={`genre`}
                              name="genre"
                              required
                              value={formData.contacts.genre}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            >
                              <option value="">Sélectionner</option>
                              <option value="M">Masculin</option>
                              <option value="F">Feminin</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div
                        className={`h-px ${
                          isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
                        }`}
                      />

                      {/* ==================================================
              ADDRESS
          ================================================== */}
                      <div>
                        <div className="mb-4 flex items-center gap-2">
                          <div
                            className={`flex h-6 w-6 items-center justify-center rounded-md ${
                              isDarkMode
                                ? "bg-emerald-500/10 text-emerald-400"
                                : "bg-emerald-50 text-emerald-600"
                            }`}
                          >
                            <i className="fas fa-location-dot text-[8px]" />
                          </div>

                          <p
                            className={`text-[10px] font-semibold ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Adresse principale & Profession
                          </p>
                        </div>

                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                          {/* Avenue */}
                          <div className="sm:col-span-2">
                            <label
                              htmlFor="avenue"
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              <i className="fas fa-road mr-1.5 text-[8px] text-gray-500" />
                              Avenue <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              name="avenue"
                              id="avenue"
                              required
                              value={formData.contacts.avenue}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Quartier */}
                          <div>
                            <label
                              htmlFor="quartier"
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Quartier <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              name="quartier"
                              id="quartier"
                              required
                              value={formData.contacts.quartier}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Commune */}
                          <div>
                            <label
                              htmlFor="commune"
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              Commune <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              name="commune"
                              id="commune"
                              required
                              value={formData.contacts.commune}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Ville */}
                          <div className="sm:col-span-1 lg:col-span-2">
                            <label
                              htmlFor="ville"
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              <i className="fas fa-city mr-1.5 text-[8px] text-gray-500" />
                              Ville <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              name="ville"
                              id="ville"
                              value={formData.contacts.ville}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Telephone */}
                          <div className="sm:col-span-1 lg:col-span-2">
                            <label
                              htmlFor="telephone"
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              <i className="fas fa-phone mr-1.5 text-[8px] text-gray-500" />
                              Téléphone <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="tel"
                              name="telephone"
                              id="telephone"
                              placeholder="Ex: +243990119611"
                              required
                              value={formData.contacts.telephone}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200 placeholder:text-gray-600"
                                  : "border-gray-200 bg-white text-gray-700 placeholder:text-gray-400"
                              }`}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className={`h-px ${
                          isDarkMode ? "bg-[#30363D]" : "bg-gray-200"
                        }`}
                      />

                      {/* ==================================================
              CONTACT & PROFESSION
          ================================================== */}
                      <div>
                        <div className="mb-4 flex items-center gap-2">
                          <div
                            className={`flex h-6 w-6 items-center justify-center rounded-md ${
                              isDarkMode
                                ? "bg-amber-500/10 text-amber-400"
                                : "bg-amber-50 text-amber-600"
                            }`}
                          >
                            <i className="fas fa-address-book text-[8px]" />
                          </div>

                          <p
                            className={`text-[10px] font-semibold ${
                              isDarkMode ? "text-gray-300" : "text-gray-700"
                            }`}
                          >
                            Contact & activité professionnelle
                          </p>
                        </div>

                        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                          {/* Email */}
                          <div>
                            <label
                              htmlFor={`email`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              <i className="fas fa-envelope mr-1.5 text-[8px] text-gray-500" />
                              Email
                            </label>

                            <input
                              type="text"
                              id={`email`}
                              name="email"
                              value={formData.contacts.email}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>

                          {/* Profession */}
                          <div>
                            <label
                              htmlFor={`profession`}
                              className={`mb-1.5 block text-[10px] font-medium ${
                                isDarkMode ? "text-gray-300" : "text-gray-700"
                              }`}
                            >
                              <i className="fas fa-briefcase mr-1.5 text-[8px] text-gray-500" />
                              Profession <span className="text-red-500">*</span>
                            </label>

                            <input
                              type="text"
                              id={`profession`}
                              name="profession"
                              value={formData.contacts.profession}
                              onChange={handleContactsChange}
                              className={`h-10 w-full rounded-lg border px-3 text-xs outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-500/10 ${
                                isDarkMode
                                  ? "border-[#30363D] bg-[#161B22] text-gray-200"
                                  : "border-gray-200 bg-white text-gray-700"
                              }`}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* ==================================================
        FOOTER
    ================================================== */}
                <div
                  className={`fixed bottom-0 left-20 right-0 z-40 border-t backdrop-blur-md md:left-60 ${
                    isDarkMode
                      ? "border-[#30363D] bg-[#0D1117]/95"
                      : "border-gray-200 bg-white/95"
                  }`}
                >
                  <div className="flex min-h-16 items-center justify-between gap-3 px-4 py-3 sm:px-6 lg:px-8">
                    {/* Previous */}
                    <button
                      type="button"
                      onClick={() => setActiveTab("coordonnees")}
                      className={`flex h-9 items-center gap-2 rounded-lg border px-3 sm:px-4 text-[10px] font-medium transition ${
                        isDarkMode
                          ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                          : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                      }`}
                    >
                      <i className="fas fa-arrow-left text-[8px]" />
                      <span className="hidden sm:inline">Précédent</span>
                    </button>

                    <div className="flex items-center gap-2">
                      {/* Cancel */}
                      <button
                        //go back to student list page
                        onClick={() => navigate("/parametre")}
                        className={`flex h-9 items-center gap-2 rounded-lg border px-3 sm:px-4 text-[10px] font-medium transition ${
                          isDarkMode
                            ? "border-[#30363D] bg-[#161B22] text-gray-300 hover:bg-[#21262D]"
                            : "border-gray-200 bg-white text-gray-600 hover:bg-gray-50"
                        }`}
                      >
                        <i className="fas fa-times text-[8px]" />
                        <span className="hidden sm:inline">Annuler</span>
                      </button>

                      {/* Existing parent */}
                      {!showAddParentForm ? (
                        <button
                          onClick={() => {
                            //validate required filds
                            const { parent_id } = formData;
                            if (!parent_id) {
                              return showNotification(
                                "Veuillez sélectionner un parent",
                                "error",
                              );
                            }

                            handleCreateStudent();
                            // console.log(formData);
                          }}
                          className="flex h-9 items-center gap-2 rounded-lg bg-blue-600 px-3 text-[10px] font-semibold text-white transition hover:bg-blue-700 sm:px-4"
                        >
                          {mutationCreateStudentMeth2.isPending ? (
                            <span className="flex items-center justify-center">
                              <i className="fas fa-spinner fa-spin mr-2"></i>
                              Chargement...
                            </span>
                          ) : (
                            <>
                              <i className="fas fa-check text-[8px]" />
                              <span className="hidden sm:inline">
                                Valider inscription
                              </span>
                              <span className="sm:hidden">Valider</span>
                            </>
                          )}
                        </button>
                      ) : (
                        /* New parent */
                        <button
                          onClick={() => {
                            //validate required filds
                            const {
                              nom,
                              postnom,
                              prenom,
                              type,
                              genre,
                              ville,
                              commune,
                              quartier,
                              avenue,
                              profession,
                            } = formData.contacts;

                            if (
                              !nom.trim() ||
                              !postnom.trim() ||
                              !prenom.trim() ||
                              !type.trim() ||
                              !genre.trim() ||
                              !ville.trim() ||
                              !commune.trim() ||
                              !quartier.trim() ||
                              !avenue.trim() ||
                              !profession.trim()
                            ) {
                              return showNotification(
                                "Veuillez compléter tous les champs obligatoires",
                                "error",
                              );
                            }

                            const result = phoneSchema.safeParse(
                              formData.contacts.telephone,
                            );

                            if (!result.success) {
                              showNotification(
                                result.error.issues[0].message,
                                "error",
                              );
                              return;
                            }

                            handleCreateStudentAndParent();
                            // console.log(formData);
                          }}
                          className="flex h-9 items-center gap-2 rounded-lg bg-blue-600 px-3 text-[10px] font-semibold text-white transition hover:bg-blue-700 sm:px-4"
                        >
                          {mutationCreateParent.isPending ? (
                            <span className="flex items-center justify-center">
                              <i className="fas fa-spinner fa-spin mr-2"></i>
                              Chargement...
                            </span>
                          ) : (
                            <>
                              <i className="fas fa-check text-[8px]" />
                              <span className="hidden sm:inline">
                                Valider inscription
                              </span>
                              <span className="sm:hidden">Valider</span>
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 rounded-lg text-white shadow-lg transition-all duration-500 z-[60] ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          <span className="text-sm">{notification.message} </span>
        </div>
      )}
    </div>
  );
};
export default NewStudent;
